export const faqs = [
  {
    title: 'Video Interview',
    icon: 'faq-video.svg',
    questions: [
      {
        id: 1,
        name: 'How do I create an asynchronous video interview?',
        answer: `<b>1. Interview İnformation </b> <br/>
          Type the name of the video call you will create. Only you can see the interview information, candidates cannot. This information is necessary for you to distinguish interviews in the listing area. In addition, if you want to benefit from the professional questions suggested by artificial intelligence, you can also choose the position you will interview from the AI Assistant field. Thus, in the next step, you can also benefit from the professional question suggestions of artificial intelligence.
          After adding a title for the video call, you can proceed to the adding question step.<br/>
          <b>2.Prepare Question</b><br/>
          You can add your own questions and choose questions from interview.co's question bank. If you choose your interview position in the previous step, artificial intelligence offers questions that you can ask professionally. This way you can choose from both general and professional questions. You should also give the candidate a choice of reflection time and answer time to answer the question. Reflection time is the time you set for the candidate to think about the question before answering it after seeing it. Response time is the amount of time you set for the candidate to answer the question after completing the reflection time.<br/>
          <b>3.Preview</b><br/>
          In the last step, you can preview the questions you have prepared and the thinking and answering times.`,
      },
      {
        id: 2,
        name: 'What is thinking time?',
        answer: 'The thinking time is the time you set for the candidate to think about the question after seeing the question before answering it.You can set a minimum 15 seconds maximum 120 seconds thinking time.',
      },
      {
        id: 3,
        name: 'What is answering time?',
        answer: 'Answering time is the time you set for the candidate to answer the question after the thinking time is completed. You can set a minimum 15 seconds maximum 150 seconds thinking time. ',
      },
      {
        id: 4,
        name: 'Is there a sample question I can ask the candidate?',
        answer: 'Of course, if you wish, you can also choose a question from the question bank of interview.co <br/> Interview.co question bank includes both general questions and professional questions. For professional questions, you need to choose your position at the interview information stage. When you choose your position, artificial intelligence offers professional question suggestions.',
      },
      {
        id: 5,
        name: 'How can I send the video interview I created to the candidates?',
        answer: 'You can send by clicking the send interview button on the interview card you want to send. Here you need the candidate\'s name, surname and e-mail address. You can write this information one by one or upload it in excel format.',
      },
      {
        id: 6,
        name: 'How long does it take for the candidate of the video interview I sent to be completed?',
        answer: 'The candidate must complete the video interview you sent within 7 days.The link of the video interviews you sent becomes invalid after 7 days.',
      },
      {
        id: 7,
        name: 'What happens if the candidate does not complete the video interview within the specified time?',
        answer: 'The link of the video interviews you sent becomes invalid after 7 days.',
      },
      {
        id: 8,
        name: 'Can I delete the excel format I uploaded?',
        answer: 'If you want to delete the excel you have installed, you can click on the trash icon next to the excel.',
      },
      {
        id: 9,
        name: 'Why were interviews sent to only some of the candidates I wanted to send?',
        answer: 'If an attempt is made to send an interview to the same candidate within 7 days or if the balance is insufficient, the candidates cannot be interviewed.',
      },
      {
        id: 10,
        name: 'Why isn\'t my video interview being sent?',
        answer: `There could be several reasons for this. Firstly; <br/>
          1-If you have uploaded with Excel, you should check whether the excel you uploaded is suitable for the format. If there is a format error, a warning is displayed enclosed in a red box. If the warning fields are not adapted to the format, the interview will not be sent. <br/>
          2-You should write the names, surnames and e-mail information of the candidates in handwriting in accordance with the format. If the warning fields are not adapted to the format, the interview will not be sent. <br/>
          3-Your conversations will not be sent due to lack of credit. <br/>
          4-You cannot send an interview to the same candidate again within 7 days. The validity period of the interview is 7 days. However, you can send an interview to the same candidate again after 7 days.`,
      },
      {
        id: 11,
        name: 'I have 20 Credits but I wanted to send it to 30 candidates. In this case, which candidates is it sending to?',
        answer: 'If you add more candidates than your credit, your interview will not be sent. You can send an interview by adding as many candidates as your credit.',
      },
      {
        id: 12,
        name: ' Can I send a different interview to the candidate I sent within 7 days?',
        answer: 'Yes, you can send a different interview to the same candidate. You can\'t just send the same interview to the same candidate within 7 days.',
      },
      {
        id: 13,
        name: 'How can I check the completion status of the video interviews I sent?',
        answer: 'You can view the number of completed and incomplete interviews sent from the card of your live or inactive interviews. When you click on the interview card, you can see the information of the submitted, completed and uncompleted candidates.',
      },
      {
        id: 14,
        name: 'How can I manage my candidate evaluation process in interview.co?',
        answer: 'While watching the interviews of the candidates who have completed the interview, you can take notes about the candidate in the note field. You can also score candidates out of 5 for each question you ask. The average of your scores for each question is reflected on the candidate card.',
      },
      {
        id: 15,
        name: 'Can I get the interview results in excel file?',
        answer: 'After scoring all the questions, you can see the interview results as the average score next to the candidate card. But there is no download function in the form of excel file.',
      },
      {
        id: 16,
        name: 'Is it possible to examine the candidates who have completed the interview by filtering them with their name, surname and e-mail address? If not, what can we suggest as an alternative?',
        answer: 'Candidates can be searched among the interviews sent according to their names, and the desired candidate can be easily reached.',
      },
    ],
  },
  {
    title: 'After The Interview',
    icon: 'faq-interview.svg',
    questions: [
      {
        id: 1,
        name: 'Passive mülakatı nasıl etkinleştirebilirim?',
        answer: 'Sol menüde yer alan Video İnterview>Passive alanına tıklamalıısnız. Aktife almak istediğiniz mülakat kartının üzerinde yer alan <Make İnterview Active> butonuna tıklayarak pasif mülakatınızı yayına alabilirsiniz.',
      },
      {
        id: 2,
        name: 'How can I edit the video interview I created before?',
        answer: 'You can select the edit option by clicking the three dots next to the interview you want to passively take.',
      },
      {
        id: 3,
        name: 'Can I change the questions of the video interviews I created before?',
        answer: 'If you haven\'t sent the candidates to the interview you created before, you can add or remove questions. However, if you sent the interview you created before to candidates, you can only update the title of the position.',
      },
      {
        id: 4,
        name: 'I changed the position title of the video interview I sent to candidates before. Will there be any updates to the emails sent to the candidates?',
        answer: 'Candidates will not see the position title you type while creating a video interview. The position title is a field you write so that you can follow your video interviews. No position is specified in the e-mail sent to the candidate.',
      },
      {
        id: 5,
        name: 'Can I see the date I last updated in the video interview?',
        answer: 'Yes, you can see. The interview card contains the date of the last update.',
      },
      {
        id: 6,
        name: 'Can I send a video interview to a candidate to whom I sent a video interview before?',
        answer: 'You cannot send the same interview to the same candidate within 7 days. However, you can send different interviews to the same candidate.',
      },
      {
        id: 7,
        name: 'How can I passive the active interview?',
        answer: 'You can activate the video interview you want to take from the passive interviews area by clicking the make interview active option.',
      },
      {
        id: 8,
        name: 'Can I copy an interview I\'ve already created?',
        answer: 'Yes, if you click on the three dots next to the interview you want to copy and select the copy option, you will have copied the content of your video interview on interview.co.',
      },
    ],
  },
  {
    title: 'Candidates',
    icon: 'faq-candidates.svg',
    questions: [
      {
        id: 1,
        name: 'How can I share candidates video interviews with my teammates?',
        answer: 'You can share it with the link, all users can view it.',
      },
      {
        id: 2,
        name: 'How are my video interview requests communicated to candidates?',
        answer: 'Your video features are sent to the candidates by e-mail. Also, if the candidates do not attend the video interview, a reminder e-mail will be sent the next day.',
      },
      {
        id: 3,
        name: 'If the candidate closes the video interview before completing it, can the candidate continue from where she left off?',
        answer: '',
      },
      {
        id: 4,
        name: 'How long does it take for the candidate to complete the video interview?',
        answer: 'When creating a video interview, you set thinking time and response time for each question. This time should be between 15 seconds and 120 seconds for thinking and between 15 seconds and 150 seconds for answering. Therefore, the candidate\'s time to complete the interview will vary depending on the number of questions you ask, the thinking and answering time you set.',
      },
      {
        id: 5,
        name: 'At what times is communication to the candidate made?',
        answer: 'As soon as you send the video interview, an e-mail is sent to the candidate.',
      },
    ],
  },
  {
    title: 'Account',
    icon: 'faq-account.svg',
    questions: [
      {
        id: 1,
        name: 'How can I invite team memberce to interview.co?',
        answer: 'You can invite them by clicking the add new user option in the users section of your account.',
      },
      {
        id: 2,
        name: 'What is the difference between admin and team members user?',
        answer: 'There is no role difference between users.',
      },
      {
        id: 3,
        name: 'How can I delete a team members user?',
        answer: 'You can delete the user you want to delete from the users section in your account by clicking delete at the three dots.',
      },
      {
        id: 4,
        name: 'How can I edit user information?',
        answer: 'In your account, you can edit the name and surname information by clicking on the three dots next to the user you want to edit from the users section.',
      },
      {
        id: 5,
        name: 'Can I share video interviews with team members?',
        answer: 'You can share it with the link, all users can view it.',
      },
      {
        id: 6,
        name: 'How can I change my user information?',
        answer: 'You can change your password in the my profile section of your account.',
      },
    ],
  },
  {
    title: 'Pricing',
    icon: 'faq-pricing.svg',
    questions: [
      {
        id: 1,
        name: 'How much does Interview.co cost?',
        answer: 'It depends on the plan you choose. Package prices vary on a monthly or annual basis.',
      },
      {
        id: 2,
        name: 'How can I make the payment?',
        answer: 'You can pay directly from interview.co using your credit or debit card.',
      },
      {
        id: 3,
        name: 'What happens when my trial ends?',
        answer: 'As you probably already know, you have a 1-month free trial if you haven\'t experienced it before. You get 25 credits for 1 month. Whichever you choose from the Silver, Gold or Platinum packages, you can proceed by paying within the platform, or you can contact us if you want a special plan.',
      },
      {
        id: 4,
        name: 'What happens if my credits expire early?',
        answer: 'You can take advantage of the additional packages that we will offer you by contacting us, but very soon you will be able to purchase additional packages online.',
      },
      {
        id: 5,
        name: 'Can I cancel my subscription?',
        answer: 'You can cancel your subscription from the subscription information field.',
      },
    ],
  },
  {
    title: 'Legal',
    icon: 'faq-legal.svg',
    questions: [],
  },
];
